
// // ProductList:
// // יוצר רשימת מחלקות ומוצרים לפי מחלקה נבחרת

// import React, { useEffect, useState } from 'react';
// import { Button } from '@mui/material';
// import { GetProductsByCategoryId } from "../utils/product";
// import { GetCategories } from "../utils/categoryAPI";
// import SingleProductDesktop from "./SingleProductDesktop";
// import { useDispatch, useSelector } from 'react-redux';
// import { setSelectedCategoryId } from '../features/categoriesSlice';

// export default function ProductList({ setCategoryId }) {
//     const [categories, setCategories] = useState([]);
//     const selectedCategoryId = useSelector(state => state.categries.selectedCategoryId);
//     // const [selectedCategory, setSelectedCategory] = useState(0);
//     const [products, setProducts] = useState([]);
//     const dispatch = useDispatch();

//     useEffect(() => {
//         GetCategories().then((data) => {
//             console.log("Categories:", data); // הוספת הודעת דיבאג
//             setCategories(data)
//         });
//     }, []);

//     const handleClickSelectedCategory = (categoryId) => {
//         let value = (categoryId == selectedCategoryId) ? -1: categoryId;
//         dispatch(setSelectedCategoryId(value));
//     }

//     return (
//         <div>
//             <div>
//                 {categories?.map(category =>
//                     <Button style={{ margin: '12px' }} variant="contained" color={category.id == selectedCategoryId? "primary": "secondary"}
//                         key={category.id} onClick={() => handleClickSelectedCategory(category.id)}>
//                         {category.nameCategor}
//                     </Button>
//                 )}
//             </div>
//             <div>
//                 {/* {products
//                     .map((product) => (
//                         <SingleProductDesktop key={product.id} product={product} />
//                     ))
//                     } */}
//             </div>
//         </div>
//     );
// }
// ProductList.jsx
// מציג קטגוריות ראשיות -> תתי־קטגוריות -> מוצרים

// ProductList.jsx
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  CircularProgress,
  Popover,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from '@mui/material';

import { GetCategories } from '../utils/categoryAPI';
// import { GetProductsById } from '../utils/product';
import { GetProducts } from '../utils/product';
import { useDispatch } from 'react-redux';
import { setCategries } from '../features/categoriesSlice';
import SingleProductDesktop from './SingleProductDesktop';
import { GetproductById } from "../utils/product";
import { useNavigate } from 'react-router-dom';

// עזר לשמות parent שונים
const getParentId = (c) => c?.parentCategoryId ?? c?.parentCategoryID ?? null;

export default function ProductList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // קטגוריות
  const [categories, setCategories] = useState([]);
  const [catLoading, setCatLoading] = useState(true);
  const [catError, setCatError] = useState('');

  // בחירות
  const [selectedRootId, setSelectedRootId] = useState(null);

  // חלונית תתי־קטגוריות
  const [anchorEl, setAnchorEl] = useState(null);
  const [openRootId, setOpenRootId] = useState(null);

  // מוצרים
  const [selectedSubId, setSelectedSubId] = useState(null);
  const [products, setProducts] = useState([]);
  const [prodLoading, setProdLoading] = useState(false);
  const [prodError, setProdError] = useState('');

  // טעינת קטגוריות מהשרת
  useEffect(() => {
    let mounted = true;
    setCatLoading(true);
    setCatError('');
    GetCategories()
      .then((data) => {
        if (!mounted) return;
        const arr = Array.isArray(data) ? data : [];
        setCategories(arr);
        dispatch(setCategries(arr));
      })
      .catch((e) => {
        if (!mounted) return;
        console.error(e);
        setCatError('נכשלה טעינת קטגוריות');
      })
      .finally(() => {
        if (mounted) setCatLoading(false);
      });
    return () => { mounted = false; };
  }, [dispatch]);

  // קטגוריות ראשיות
  const rootCategories = useMemo(
    () => categories.filter((c) => !getParentId(c)),
    [categories]
  );
                                                            
  // תתי־קטגוריות עבור root פתוח בחלונית
  const subOfOpenRoot = useMemo(() => {
    if (!openRootId) return [];
    return categories.filter((c) => getParentId(c) === openRootId);
  }, [categories, openRootId]);

  // פתיחת חלונית על root
  const handleOpenRoot = (event, rootId) => {
    setSelectedRootId(rootId);
    setOpenRootId(rootId);
    setAnchorEl(event.currentTarget);
    // איפוסים
    setSelectedSubId(null);
    setProducts([]);
    setProdError('');
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setOpenRootId(null);
  };

  // בחירת תת־קטגוריה מתוך החלונית
  const handleSelectSub = async (subId) => {
    setSelectedSubId(subId);
    handleClosePopover();
    // setProdLoading(true); 
    // setProdError('');
    // setProducts([]);
    // try {
    //   const prods = await GetProducts({
    //     categoryId: subId,
    //   });
    //   setProducts(Array.isArray(prods) ? prods : []);
    // } catch (e) {
    //   console.error(e);
    //   setProdError('נכשלה טעינת מוצרים');
    // } finally {
    //   setProdLoading(false);
    // }
    // עוברים לעמוד שמציג מוצרים לפי תת־קטגוריה
    navigate(`/products/sub/${subId}`);
  };

  const popoverOpen = Boolean(anchorEl);

  return (
    <Box p={2} dir="rtl">
      {/* קטגוריות ראשיות */}
      {/* <Typography variant="h5" fontWeight="bold" mb={2}>
        קטגוריות
      </Typography> */}

      {catLoading ? (
        <Stack alignItems="center" py={4}><CircularProgress /></Stack>
      ) : catError ? (
        <Typography color="error">{catError}</Typography>
      ) : (
        <Box
          dir="rtl"
          sx={{
            display: "block",
            width: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            mb: 2,
            "&::-webkit-scrollbar": { display: "none" }, // אופציונלי להסתרת סקרול
          }}
        >
          {rootCategories.map((cat) => (
            <Button
              key={cat.id}
              onClick={(e) => handleOpenRoot(e, cat.id)}
              variant="text"
              size="medium"
              sx={{
                mx: 0.75,
                py: 0.75,
                mt: 1.5,
                minWidth: "auto",
                whiteSpace: "nowrap",
                fontSize: { xs: 18, sm: 30 },
                fontWeight: 900,
                textTransform: "none",           // בלי המרה לאותיות גדולות
                letterSpacing: "0.2px",
                lineHeight: 1.1,
                fontFamily: '"Rubik","Heebo","Assistant",sans-serif', // כתב דומה לתמונה
                color: "#D81B60",
                // אין מסגרת, אין רקע (נשאר כפתור טקסט נקי)
              }}
            >
              {cat.nameCategor}
            </Button>
          ))}

          {rootCategories.length === 0 && (
            <Typography component="span" color="text.secondary">
              אין קטגוריות
            </Typography>
          )}
        </Box>
      )}


      {/* חלונית עם רשימת תתי־קטגוריות */}
      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2,
            minWidth: { xs: 360, md: 640 },  // מלבן רחב, ללא גלילה
            maxWidth: 960,
            boxShadow: 6,
            overflow: 'visible',
            direction: 'rtl',
          },
        }}
      >
        {/* === כאן הקסם: עמודות מרובות === */}
        <Box
          dir="rtl"
          sx={{
            columnCount: { xs: 2, md: 2 },     // כמו בתמונה: 2 עמודות במובייל, 4 בדסקטופ
            columnGap: 1,                      // רווח בין עמודות
            // ריווח פנימי
            py: 0.5,
          }}
        >
          {subOfOpenRoot.length ? (
            subOfOpenRoot.map((sub) => (
              <Box
                key={sub.id}
                onClick={() => handleSelectSub(sub.id)}
                sx={{
                  // כל פריט מתנהג כ"קישור" בעמודה
                  display: 'block',
                  breakInside: 'avoid',        // שלא יישבר בין עמודות
                  cursor: 'pointer',
                  color: '#D81B60',
                  textAlign: 'right',
                  fontFamily: '"Rubik","Heebo","Assistant",sans-serif',
                  fontSize: { xs: 16, md: 18 },
                  fontWeight: 700,
                  lineHeight: 1.6,
                  py: 0.25,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {sub.nameCategor}
              </Box>
            ))
          ) : (
            <Box sx={{ color: 'text.secondary', py: 1 }}>אין תתי־קטגוריות לקטגוריה זו</Box>
          )}
        </Box>
      </Popover>


      {/* מוצרים של התת־קטגוריה שנבחרה */}
      {/* {selectedSubId && (
        <>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} mt={1}>
            <Typography variant="h6" fontWeight="bold">מוצרים</Typography>
            <Button
              variant="text"
              onClick={() => { setSelectedSubId(null); setProducts([]); }}
            >
              ניקוי בחירת תת־קטגוריה
            </Button>
          </Stack>

          {prodLoading ? (
            <Stack alignItems="center" py={4}><CircularProgress /></Stack>
          ) : prodError ? (
            <Typography color="error">{prodError}</Typography>
          ) : products.length === 0 ? (
            <Typography color="text.secondary">אין מוצרים להצגה</Typography>
          ) : (
            <Grid container spacing={2}>
              {products.map((p) => (
                <Grid item key={p.id} xs={12} sm={6} md={4} lg={3}>
                  <SingleProductDesktop product={p} />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )} */}
    </Box>
  );
}